import Paper from "@mui/material/Paper";
import React, {ReactNode, useEffect, useRef} from "react";
import {sx} from './sx';
import {Box} from "@mui/material";

interface IProps {
    children: React.ReactNode
    moveComponent: ReactNode
    showResetBtn?:boolean;
}

const DraggableCustom = ({
                             children,
                             moveComponent
                         }: IProps) => {

    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const panelRef = useRef<HTMLDivElement | null>(null);

    const position = useRef({
        startX: 0,
        startY: 0,
        dx: 0,
        dy: 0,
    });

    const startDrag = (event: MouseEvent) => {
        if (event.button !== 0 || !panelRef.current) return;
        document.addEventListener("mousemove", onDrag);
        position.current.startX = event.pageX - position.current.dx;
        position.current.startY = event.pageY - position.current.dy;
    };

    const onDrag = (event: MouseEvent) => {
        if (!wrapperRef.current || !panelRef.current) {
            return
        };

        const container = wrapperRef.current.parentElement;

        if (!container){
            return
        }

        const containerRect = container.getBoundingClientRect();
        const panelRect = wrapperRef.current.getBoundingClientRect(); // беремо розміри обгортки

        let tx = event.pageX - position.current.startX;
        let ty = event.pageY - position.current.startY;

        const minX = 0;
        const minY = 0;
        const maxX = containerRect.width - panelRect.width;
        const maxY = containerRect.height - panelRect.height;

        if (tx < minX) tx = minX;
        if (ty < minY) ty = minY;
        if (tx > maxX) tx = maxX;
        if (ty > maxY) ty = maxY;

        wrapperRef.current.style.transform = `translate(${tx}px, ${ty}px)`;

        position.current.dx = tx;
        position.current.dy = ty;
    };

    const stopDrag = () => {
        document.removeEventListener("mousemove", onDrag);
    };

    useEffect(() => {
        const panel = panelRef.current;

        if (panel) {
            panel.addEventListener("mousedown", startDrag);
        }

        document.addEventListener("mouseup", stopDrag);

        return () => {
            if (panel) {
                panel.removeEventListener("mousedown", startDrag);
            }
            document.removeEventListener("mouseup", stopDrag);
            document.removeEventListener("mousemove", onDrag);
        };
    }, []);

    return (
        <Paper
            ref={wrapperRef}
            sx={sx.root}
        >
            <Box
                sx={sx.move}
                ref={panelRef}
            >
                {moveComponent}
            </Box>

            {children}
        </Paper>
    );
};

export default DraggableCustom;
